import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "pl", label: "Polski" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
] as const;

export type LanguageCode = (typeof LANGUAGES)[number]["code"];

export const isValidLanguage = (lang?: string): lang is LanguageCode =>
  !!lang && LANGUAGES.some((l) => l.code === lang);

export function useLanguageSync(lang?: string) {
  const { i18n } = useTranslation();

  useEffect(() => {
    const target = isValidLanguage(lang) ? lang : "en";
    if (i18n.language !== target) {
      i18n.changeLanguage(target);
    }
    if (document.documentElement.lang !== target) {
      document.documentElement.lang = target;
    }
  }, [lang, i18n]);
}